import { render, staticRenderFns } from "./AppLogin.vue?vue&type=template&id=8ba80aaa"
import script from "./AppLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLogin.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports